import api from './api';

export const settingService = {
  getAll: () => api.get('/site-settings'),
  getByKey: (key) => api.get(`/site-settings/${key}`),
  updateSettings: (data) => api.put('/site-settings', data),
  upsertSingle: (data) => api.post('/site-settings/single', data)
};
